/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export enum LanguageCode {
  EN = 'EN',
  EN_IE = 'EN_IE',
  ES = 'ES',
  FR = 'FR',
  DE = 'DE',
  IT = 'IT',
  PT = 'PT',
  NL = 'NL',
  RU = 'RU',
  PL = 'PL',
  SV = 'SV',
  NO = 'NO',
  DA = 'DA',
  FI = 'FI',
  EL = 'EL',
  CS = 'CS',
  SK = 'SK',
  HU = 'HU',
  RO = 'RO',
  BG = 'BG',
  HR = 'HR',
  SR = 'SR',
  SL = 'SL',
  ET = 'ET',
  LV = 'LV',
  LT = 'LT',
  GA = 'GA',
  CY = 'CY',
  EU = 'EU',
  CA = 'CA',
  GL = 'GL',
  IS = 'IS',
  UK = 'UK',
  BE = 'BE',
  MK = 'MK',
  SQ = 'SQ',
}
